import React from 'react';
import moment from 'moment';
import './EventsTimeline.css';

interface Event {
  eventname: string;
  timestamp: string; // ISO format string from backend
  receiveTimestamp: string;
}

interface EventsTimelineProps {
  events: Event[];
  currentTime?: number;
  onEventClick?: (timestamp: number) => void;
}

const EventsTimeline: React.FC<EventsTimelineProps> = ({
                                                         events,
                                                         currentTime,
                                                         onEventClick
                                                       }) => {
  const formatEventTime = (timestamp: string) => {
    // return moment(timestamp).format('HH:mm:ss.SSS');
    return moment.utc(timestamp).local().format('HH:mm:ss.SSS');
  };

  if (!events || events.length === 0) {
    return (
        <div className="events-timeline empty">
          <p>No events found for this call</p>
        </div>
    );
  }

  return (
      <div className="events-timeline">
        <h3>ESS Events ({events.length} events)</h3>
        <div className="events-list">
          {events.map((event, index) => {
            const eventTimestamp = moment(event.timestamp).valueOf();
            const isActive = currentTime &&
                Math.abs(eventTimestamp - currentTime) < 5000;

            return (
                <div
                    key={`${event.timestamp}-${index}`}
                    className={`event-item ${isActive ? 'active' : ''}`}
                    onClick={() => onEventClick && onEventClick(eventTimestamp)}
                >
                  <div className="event-time">
                    {formatEventTime(event.timestamp)}
                  </div>
                  <div className="event-type">
                    {event.eventname}
                  </div>
                </div>
            );
          })}
        </div>
      </div>
  );
};

export default EventsTimeline;